import ApiServer from '@/utils/api/ApiServer.js'

let inFlight = null

export default {
  fetchDueDiligenceExemptions (context) {
    if (inFlight) return inFlight
    context.commit('setDueDiligenceExemptionsLoading', true)
    inFlight = ApiServer.get('dueDiligenceExemptions')
      .then(response => {
        const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name))
        context.commit('setDueDiligenceExemptions', sortedData)
        return sortedData
      })
      .finally(() => {
        context.commit('setDueDiligenceExemptionsLoading', false)
        inFlight = null
      })
    return inFlight
  },

  async deleteDueDiligenceExemption (context, dueDiligenceExemptionId) {
    const response = await ApiServer.delete(`dueDiligenceExemptions/${dueDiligenceExemptionId}`)
    context.commit('removeDueDiligenceExemption', dueDiligenceExemptionId)
    return response.data
  },

  async createDueDiligenceExemption (context, dueDiligenceExemption) {
    const response = await ApiServer.post('dueDiligenceExemptions', dueDiligenceExemption)
    context.commit('addDueDiligenceExemption', response.data)
    if (response.data.autoAssignWhenNoHits) context.commit('clearAutoAssignExcept', response.data.dueDiligenceExemptionId)
    return response.data
  },

  async updateDueDiligenceExemption (context, dueDiligenceExemption) {
    const response = await ApiServer.put(`dueDiligenceExemptions/${dueDiligenceExemption.dueDiligenceExemptionId}`, dueDiligenceExemption)
    context.commit('updateDueDiligenceExemption', response.data)
    if (response.data.autoAssignWhenNoHits) context.commit('clearAutoAssignExcept', response.data.dueDiligenceExemptionId)
    return response.data
  }
}
